import React from "react";
import RGL, { Responsive } from "react-grid-layout";
import _ from "lodash";
import MicsDisplayModule from './micsDisplayModule';
import MicsControlModule from './micsControlModule';
import ClockModule from './clockModule';
import ImageModule from './imageModule';
import WeatherDisplayModule from './weatherDisplayModule';
import TextDisplayModule from './textDisplayModule';
import TimerControlModule from './timerControlModule';
import TextControlModule from './textControlModule';
import TimerDisplayModule from './timerDisplayModule';
import ChatControlModule from './chatControlModule';
import ChatDisplayModule from './chatDisplayModule';
import WebcamControlModule from './webcamControlModule';
import AnalogClockModule from './analogClockModule';
import IFrameModule from './iFrameModule';
import AudioHub from './audioHub';
import AudioClient from './audioClient';
import ScheduleControlModule from './scheduleControlModule';
import ScheduleDisplayModule from './scheduleDisplayModule';
import DisplayLog from './displayLog';
import Request from 'superagent';
import FlashScreen from './flashScreen';
import io from "socket.io-client";
import socketStream from "socket.io-stream";
import { MenuItem, DropdownButton, Button, Modal, Badge} from 'react-bootstrap';
import RmToolTip from './rmToolTip';
import EventSystem from './EventSystem';
import GlobalFunction from './globalFunction';
import WidthProvider from './WidthProvider';
import moment from 'moment';
//import htmlScreenCaptureJs from "htmlScreenCaptureJs";
import './css/displayClock.css';
import {RmModal, RmModalContent, RmModalHeader, RmModalBody, RmModalInput,
  RmModalFooter, RmModalTextarea} from './style/tile.style';

import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import '../node_modules/react-bootstrap-table/dist/react-bootstrap-table-all.min.css';


//const ResponsiveReactGridLayout = WidthProvider(RGL);
const ResponsiveReactGridLayout = WidthProvider(Responsive);
////const EventSystem = require('./EventSystem');


/**
 * This layout demonstrates how to use a grid with a dynamic number of elements.
 */
class DisplayClock extends React.PureComponent {
  static defaultProps = {
    className: "layout",
    //cols: { lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 },
    //cols: { lg: 12, md: 12, sm: 12, xs: 12, xxs: 12 },
    //rowHeight: 64,
    //verticalCompact: false,
    compactType: null,
    preventCollision: true,
    currentTImeMaster: "",
    //autoSize: true,
    rowHeight: 0
  };

    

  constructor(props) {
    super(props);

    this.state = {
      newCounter: 0,
      rowHeight: 60,
      micsVisible: false,
      clockInfo: [],
      changeCount: 0,
      popupAlert: false,
      configureWidgets: false,
      setupMode: false,
      layout: [],
      dimensions: [],
      micsMessaging:[],
      textMessaging: [],
      timerMessaging: [],
      timeMasterRequestorContact: "",
      timeMasterClockOffset: 0,
      lowClockOffset: 0,
      highClockOffset: 0,
      lowLatency: 0,
      highLatency: 0,
      clockOffset: 0,
      clockLocalOffset: 0,
      disableDrag: false,
      designSeqNoChanged: false,
      newProgramVersionAvailable: false,
      activeCalls: 0,
      webcamSetupActive: 0,
      displayLogActive: 0,
      consecutiveSocketErrorCount: 0,
      logData: [],
      noLogMessage: "",
      selectedModuleIdentifier: [],
      forceRender: false,
      forceRenderRGL: false,
      localClockOffset: 0,
      screenCaptureOn: false,
      externalDataUrl: "",
      fullScreen: false,
      //imageDetails: {base64ImageContent: "", width: 0, height: 0},
      showLog: true,
      supportsScreenShot: true,
      screenDimensions: {width: 0, height: 0},
      ticketID: 0,
      touchDevice: false,
      iOSDevice: false,
      moduleLogStatus: [],
      mounted: false,
      heartbeatsSinceLastTimeSync: 0,
      timeSyncCounter: 0,
      colours: {backgroundColor: "#333333",
                color: "#ffffff",
                boxShadow: "0 3.2px 7.2px 0 rgba(200,200,200, 0.132), 0 0.6px 1.8px 0 rgba(200,200,200, 0.108)"},
      debugObjectArray : [],
      showDebug: false,
      webRTCDebugResultObjectArray: [{registeredName: "", debugObject: []}],
      currentSelectedWebRTC: ""
    };

    this.firstMove = true;

    this.video = React.createRef();
    this.canvas = React.createRef();
    this.container = React.createRef();

    
    this.onBreakpointChange = this.onBreakpointChange.bind(this);
    this.onDragStop = this.onDragStop.bind(this);
    this.onLayoutChange = this.onLayoutChange.bind(this);
    this.onResizeStop = this.onResizeStop.bind(this);
    this.onResizeStart = this.onResizeStart.bind(this);
    this.onResize = this.onResize.bind(this);
    this.onSendMessage = this.onSendMessage.bind(this);
    this.rightClick = this.rightClick.bind(this);
    this.popupAlert = this.popupAlert.bind(this);
    this.closeAlert = this.closeAlert.bind(this);
    this.openFullScreen = this.openFullScreen.bind(this);
    this.closeFullscreen = this.closeFullscreen.bind(this);
    this.toggleConfigureWidgets = this.toggleConfigureWidgets.bind(this);
    this.screenDataLoaded = this.screenDataLoaded.bind(this);
    this.openLoggingWindow = this.openLoggingWindow.bind(this);
    this.createTicketNoLogging = this.createTicketNoLogging.bind(this);
    this.performTimeSync = this.performTimeSync.bind(this);
    this.roomJoined = this.roomJoined.bind(this);
    this.screenResized = this.screenResized.bind(this);
    this._touchStart = this._touchStart.bind(this);
    this._touchMove = this._touchMove.bind(this);
    this.rmModal = React.createRef();
        //this.enableModuleLogging = this.enableModuleLogging.bind(this);
   
    //this.socket = io('192.168.1.176:8086');
    //this.socket = io('localhost:8086');
    this.socket = io(this.props.userProfile[0].serverSocket , { forceNew: true });
    //this.socket = io();
    this.socket.on('RECEIVE_MESSAGE', (data) => {
      // the server sent us a message
      // push it out to modules that are listening for it
      //console.log(data)
      EventSystem.publish(data.sourceModuleName, data);
      this.setState({consecutiveSocketErrorCount: 0});
    });


    //this.socket.on('RECEIVE_STREAM', function(data, blob){
      // the server sent us a message
    //  EventSystem.publish(data.sourceModuleName, data, blob);
    //});

    this.socket.on('connect', this.socketConnected.bind(this));
    this.socket.on('connect_timeout', (timeout) => {
      this.setState({consecutiveSocketErrorCount: this.state.consecutiveSocketErrorCount + 1});
      console.log('socket: connect timeout')
    });
    this.socket.on('connect_error', (error) => {
      this.setState({consecutiveSocketErrorCount: this.state.consecutiveSocketErrorCount + 1});
      console.log('socket: connect error');
      console.log(error);
    });
    this.socket.on('reconnect_attempt', (attemptNumber) => {
      this.setState({consecutiveSocketErrorCount: this.state.consecutiveSocketErrorCount + 1});
      console.log('socket: reconnect '+attemptNumber);
    });
    this.socket.on('reconnecting', (attemptNumber) => {
      this.setState({consecutiveSocketErrorCount: this.state.consecutiveSocketErrorCount + 1});
      console.log('socket: reconnecting '+attemptNumber);
    });
    this.socket.on('reconnect_error', (error) => {
      this.setState({consecutiveSocketErrorCount: this.state.consecutiveSocketErrorCount + 1});
      console.log('socket: reconnect_error '+error);
    });
    this.socket.on('reconnect_failed', () => {
      this.setState({consecutiveSocketErrorCount: this.state.consecutiveSocketErrorCount + 1});
      console.log('socket: reconnect_failed ');
    });
    
   


    this.socket.on('ROOM_JOINED', this.roomJoined);
   
    this.socket.on('ROOM_LIST', this.roomListReceived.bind(this));
    this.socket.on('TIME_OFFSET', this.timeOffsetReceived.bind(this));
    this.socket.on('TIME_MASTER', this.timeMasterDataReceived.bind(this));
    this.socket.on('VERSION_UPDATE', this.onVersionUpdate.bind(this));
    this.socket.on('TICKET_RAISED', this.onTicketRaised.bind(this));

    


  }
  components = {
    ClockModule: ClockModule,
    ImageModule: ImageModule,
    WeatherDisplayModule: WeatherDisplayModule,
    MicsDisplayModule: MicsDisplayModule,
    MicsControlModule: MicsControlModule,
    ChatControlModule: ChatControlModule,
    ChatDisplayModule: ChatDisplayModule,
    TextDisplayModule: TextDisplayModule,
    TextControlModule: TextControlModule,
    TimerDisplayModule: TimerDisplayModule,
    TimerControlModule: TimerControlModule,
    WebcamControlModule: WebcamControlModule,
    AnalogClockModule: AnalogClockModule,
    IFrameModule: IFrameModule,
    AudioHub: AudioHub,
    AudioClient: AudioClient,
    ScheduleControlModule: ScheduleControlModule,
    ScheduleDisplayModule: ScheduleDisplayModule
  };

  socketConnected() {
    
    this.setState({consecutiveSocketErrorCount: 0});

    this.setState({socketID: this.socket.id});
    let messageObject={};
      //messageObject.params=this.props.parameters;
      messageObject.sourceModuleName='displayClock';
      messageObject.customerID=this.props.userProfile[0].customer_id;
      messageObject.siteID=this.props.userProfile[0].site_id;
      messageObject.eventID=this.props.selectedScreen.eventID;
      messageObject.screenName=this.props.selectedScreen.screenName;
      messageObject.userAgent =window.navigator.userAgent;
      messageObject.clientPublicIP=this.props.selectedScreen.clientPublicIP;
      messageObject.action='join';
      messageObject.clientTimeAtSend = Date.now();
      let startTime = Date.now();

      this.socket.emit('JOIN_ROOM',messageObject)

      if (this.state.currentTimeMaster==="ME") {
        // we reconnected so we need to update the timeMaster with out
        // new socketID
        this.askTimeMaster('set_time_master');
        console.log('Asking timeMaster to re-register ME as the TIME_MASTER')
      } else {
        // incase we started after the timemaster was set
        this.askTimeMaster('get_time_master');
      }

      //this.setState({startTime: startTime});
      let newMessageObject={};
      this.socket.emit('REQUEST_VERSION',newMessageObject);
  }
 
  onVersionUpdate(data) {
      this.setState({consecutiveSocketErrorCount: 0});
      if (window.myBuildVersion !== data.currentBuildVersion) {
        // build version has changed 
        this.setState({newProgramVersionAvailable: true});
      } else {
        // versions the same
        this.setState({newProgramVersionAvailable: false});
      }  
  }

  roomJoined(data) {
    let endTime = Date.now(); // must use raw Date.now() as T4 — getAdjustedTime() is circular on reconnects
    let offset = ((data.serverTimeAtReceive-data.clientTimeAtSend) + (data.serverTimeAtSend-endTime))/2;
    this.setState({lowLatency: (endTime-data.clientTimeAtSend),
                   highlatency: (endTime-data.clientTimeAtSend),
                   lowClockOffset: offset,
                   highClockOffset: offset,
                   clockOffset: offset}, () => { // bootstrap clockOffset immediately so it's never stuck at 0
                   this.performTimeSync();
                   this.timerID2=setTimeout(() => {
                      this.performTimeSync();
                    }, 10000);
                   });
  }

  performTimeSync(){
   
    this.setState({loopCount: 0,
                   heartbeatsSinceLastTimeSync: 0});
    this.intervalID = setInterval(this.getServerTimeOffset.bind(this), 100);
    //this.setState({intervalID: intervalID});
    //this.getServerTimeOffset();
  }

  getAdjustedTime() {
    //let ourAdjustedTime =   Date.now() +
    //                        this.state.clockOffset -
    //                        this.state.timeMasterClockOffset + // the clockOffset in the message is from the sender
    //                       this.state.localClockOffset;
      let adjustedDate = GlobalFunction.getAdjustedDate(this.state.localClockOffset, 
                        {clockOffset: this.state.clockOffset, timeMasterClockOffset: this.state.timeMasterClockOffset});
      let ourAdjustedTime = adjustedDate.getTime();
    return ourAdjustedTime;
  }

  getServerTimeOffset() {
    if (this.state.loopCount > 8) {
      clearInterval(this.intervalID);
      // Always finalize clockOffset from the best (lowest-latency) sample found.
      // Without this, clockOffset can stay at 0 when JOIN_ROOM had the lowest RTT
      // and no TIME_OFFSET sample ever beat it.
      const bestOffset = this.state.lowClockOffset;
      this.setState({clockOffset: bestOffset}, () => {
        this.addLogEntry(['displayClock', 'displayClock'],'Time sync event # ' + this.state.timeSyncCounter + ',  offset:'+bestOffset);
        EventSystem.publish('updatedClockOffset', {clockOffset: bestOffset, timeSyncCounter: this.state.timeSyncCounter});
        this.setState(prev => ({timeSyncCounter: prev.timeSyncCounter + 1}));
      });
    }
    this.setState(prev => ({loopCount: prev.loopCount + 1}));

    let messageObject={};
    //messageObject.params=this.props.parameters;
    messageObject.clientPublicIP=this.props.selectedScreen.clientPublicIP;
    messageObject.userAgent =window.navigator.userAgent;
    messageObject.loopCount=this.loopCount;
    messageObject.action='getOffset';
    messageObject.clientTimeAtSend = Date.now();  
    //messageObject.clientTimeAtSend = this.getAdjustedTime();
    //let startTime = Date.now();

   

    this.socket.emit('TIME_OFFSET',messageObject)
  }

  timeOffsetReceived(data){

    let lowClockOffset = this.state.lowClockOffset;
    let lowLatency = this.state.lowLatency;
    let highClockOffset = this.state.highClockOffset;
    let highLatency = this.state.highLatency;
    //let endTime = this.getAdjustedTime();
    let endTime = Date.now();
//console.log(data.clientTimeAtSend, data.serverTimeAtReceive, data.serverTimeAtSend, endTime)
    let offset = ((data.serverTimeAtReceive-data.clientTimeAtSend) + (data.serverTimeAtSend-endTime))/2;
     //console.log ('Latency: '+(endTime-data.clientTimeAtSend)+'   Offset: ' + data.loopCount + ': '+ offset);
    // console.log ('Offset: ' + data.loopCount + ': '+ offset);
    //this.addLogEntry(['displayClock', 'displayClock'],'To server:'+(data.serverTimeAtReceive-data.clientTimeAtSend)+ ', from server:'+ (data.serverTimeAtSend-endTime)+', delay:'+(endTime-data.clientTimeAtSend));

    if ((endTime-data.clientTimeAtSend) < this.state.lowLatency) {
      // we want to store the results with the lowest latency
      lowClockOffset = offset;
      lowLatency = (endTime-data.clientTimeAtSend);
      //this.addLogEntry(['displayClock', 'displayClock'],'Low latency ' + lowLatency + ', low offset '+ lowClockOffset);
      this.setState({lowClockOffset: offset,
                     lowLatency: (endTime-data.clientTimeAtSend )}, ()=>{
        if ((endTime-data.clientTimeAtSend) > this.state.highLatency) {
          // we want to store the results with the highest latency
          highClockOffset = offset;
          highLatency = (endTime-data.clientTimeAtSend);
          this.setState({highClockOffset: offset}, ()=>{
            this.setState({highLatency: (endTime-data.clientTimeAtSend)}, () => {});
          });
        }

        // keep a running average as the offset
        //this.setState({clockOffset: (this.state.highClockOffset + this.state.lowClockOffset)/2 }, () => {});
        this.setState({clockOffset: this.state.lowClockOffset}, () => {});
        this.setState({consecutiveSocketErrorCount: 0});
        //console.log('Time sync offset:', this.state.lowClockOffset)
    //this.addLogEntry(['displayClock', 'displayClock'],'Time sync calc ' + this.state.lowClockOffset + ' vs '+ lowClockOffset);
        
        if (data.loopCount===10){
            console.log('Selected Offset: '+this.state.clockOffset)
        }
      });
    }

    
  }

  timeMasterDataReceived(data) {
      this.setState({consecutiveSocketErrorCount: 0});
      if (data.action==='get_time_master' ||
        data.action==='set_time_master') {
        if (data.currentTimeMaster===this.socket.id) {
            this.setState({currentTimeMaster: "ME"})
        } else {
          /** 
           * It is possible that there is no timemaster but there is a timemaster offset
           * This can happen if the timemastter disconnects at the socket level, rather than
           * intentionally. 
           * We want everyone to stay at the initial timemaster offset until the timemaster is
           * reclaimed. Otherwise the time would bounce up and down midway through an event.
           */
          this.setState({currentTimeMaster: data.currentTimeMaster})
        }
        this.setState({timeMasterClockOffset: data.timeMasterClockOffset})
    } else  if (data.action==='release_time_master'){
        // when released we have to clear who the time master is and reset the offset 
        this.setState({currentTimeMaster: ""}, () => {
          this.setState({timeMasterClockOffset: data.timeMasterClockOffset})         
        })
    } else  if (data.action==='request_release_time_master'){
      this.setState({timeMasterRequestorContact: data.contact}, () => {this.popupAlert()});
    }  
  }

  askTimeMaster(action) {
    let messageObject={};
      //messageObject.params=this.props.parameters;
      messageObject.sourceModuleName='displayClock';
      messageObject.customerID=this.props.userProfile[0].customer_id;
      messageObject.siteID=this.props.userProfile[0].site_id;
      messageObject.eventID=this.props.selectedScreen.eventID;
      messageObject.screenName=this.props.selectedScreen.screenName;
      messageObject.userAgent =window.navigator.userAgent;
      messageObject.clientPublicIP=this.props.selectedScreen.clientPublicIP;
      messageObject.action=action;
      messageObject.clockOffset=this.state.clockOffset;
      //messageObject.clientTimeAtSend = Date.now();
      messageObject.clientTimeAtSend = this.getAdjustedTime();
      
      let startTime = Date.now();
      messageObject.emit = 'TIME_MASTER';

      this.socket.emit('TIME_MASTER',messageObject);
      //console.log(messageObject);

      //this.setState({startTime: startTime});
      
  }

  roomListReceived(data){
      this.setState({consecutiveSocketErrorCount: 0});
      this.setState({clientConnections: data[this.rooomName()].length});
   
  }

  rooomName() {
    return ('Customer:'+this.props.userProfile[0].customer_id+
            ' Site:'+this.props.userProfile[0].site_id+
            ' Event:'+this.props.selectedScreen.eventID);
}



  
 
  UNSAFE_componentWillReceiveProps(nextProps){

    if (nextProps.selectedScreen.eventScreenID !== this.props.selectedScreen.eventScreenID) {
      this.getClockInfo(nextProps.selectedScreen.eventScreenID);
    }

   
    //console.log(nextProps)
  }

  showMics(data){
    this.setState({micsVisible: data.micsVisible});
  }




  getClockInfo(event_screen_id){

    let moduleLogStatus = this.state.moduleLogStatus;
    let parameters={}
    parameters.event_screen_id=event_screen_id;       

    let clockInfo = [];
    let jsonString = JSON.stringify([parameters]);
    var url= this.props.userProfile[0].serverIP + "/php/ob_clock.php?argument1=getClockInfo&argument2="+jsonString;
    Request.get(url).then((response) => {
        _.map(response.body[0].data, (dataRow) => {
            let clockInfoRow={};
            clockInfoRow = dataRow;
            if (dataRow.other_config === null) {
                clockInfoRow.other_config = {}
            } else {
                clockInfoRow.other_config = JSON.parse(dataRow.other_config);
            }
          moduleLogStatus[clockInfoRow.event_screen_module_id] = false;
          clockInfo.push(clockInfoRow);
        });
        
        // save the design_seq_no for this screen if changed
        let designSeqNo=JSON.parse(localStorage.getItem("designSeqNo_"+this.props.selectedScreen.eventScreenID));
        if (designSeqNo !== clockInfo[0].design_seq_no) {
          // all the rows contain the same value for design_seq_no, so look at the first
          // save the new value
          localStorage.setItem("designSeqNo_"+this.props.selectedScreen.eventScreenID, JSON.stringify(clockInfo[0].design_seq_no));
          this.setState({designSeqNoChanged: true});
        }

        // do this last otherwise screen paints too soon
        this.setState({clockInfo, moduleLogStatus});

    });


  }

  calculateRowHeight() {
   //set rowheight
    // we need to subtract 10 for the gaps between each row and and extra 10 for either the top or bottom
    // also subtract 30 for the top status bar and 34 for the scrollbars in windows only
    let scrollbars = 0;
    if (window.navigator.appVersion.includes('Win')) {
      scrollbars = 0;
    }
    let deductionAmount = ((this.props.selectedScreen.maxRows * 10) + 10) + 31 + scrollbars;  
    let rowHeight=Math.floor((window.innerHeight-deductionAmount)/this.props.selectedScreen.maxRows);

    return rowHeight;
  }


  openFullScreen() {
    let elem = document.documentElement;

    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) { /* Firefox */
      elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari & Opera */
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) { /* IE/Edge */
      elem.msRequestFullscreen();
    }

    this.setState({fullScreen: true});

  }

  closeFullscreen() {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    }
    this.setState({fullScreen: false});

  }


  
  componentDidMount(){
    //window.addEventListener('onTouchMove',  this._onTouchMove.bind(this), { passive: false });  
  

    if (!!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)) {
      this.setState({iOSDevice: true});
    }
  
    this.getClockInfo(this.props.selectedScreen.eventScreenID);
    this.setState({userProfile: this.props.userProfile[0]});   
    EventSystem.subscribe('MicsControlModule', this.showMics.bind(this));
    EventSystem.subscribe('MicsDisplayModule', this.showMics.bind(this));
    EventSystem.subscribe('localClockOffset', this.updateLocalClockOffset.bind(this));
    EventSystem.subscribe('webRTCdebug', this.displayWebRTCDebugInfo.bind(this));
    EventSystem.subscribe('webRTCdebugState', this.webRTCdebugStateChange.bind(this));
    EventSystem.subscribe('nameRegistered', this.nameRegistered.bind(this));
    EventSystem.subscribe('remoteWebRTCdebug', this.receivedRemoteWebRTCDebug.bind(this));
    //window.addEventListener("resize", _.debounce(() => {this.screenResized()},400));
    window.addEventListener("resize", _.debounce(this.screenResized,400));
    //window.addEventListener("touchstart", this._touchStart);
    //window.addEventListener("touchmove", this._touchMove);

    if (typeof navigator.mediaDevices === 'undefined') {
        this.setState({supportsScreenShot: false})
    } else if (typeof navigator.mediaDevices.getDisplayMedia === 'undefined') {
      this.setState({supportsScreenShot: false})
    }

     this.setState({rowHeight: this.calculateRowHeight()});


    if (this.props.selectedScreen.mode === 'test') {
      // delte the local storage as we want to see the frresh view
      localStorage.removeItem("localPostions_"+this.props.selectedScreen.eventScreenID);
    }

    let screenDimensions = {width: this.container.current.clientWidth, height: this.container.current.clientHeight};
    this.setState({screenDimensions,
                    mounted: true})

    this.refreshClock();
    
   
    this.enableModuleLogging(['displayClock','displayClock','displayClock']);
    this.addLogEntry(['displayClock', 'displayClock'], 'UA:'+window.navigator.userAgent);
    
    /*
    this.countdown = setTimeout(() => {
      window.scrollTo(0,1200);
    }, 1000);
*/
    
  }


  

  componentWillUnmount(){
    //window.removeEventListener('onTouchMove',  this._onTouchMove.bind(this));
//console.log('displaylock unmounting') 
    EventSystem.unsubscribe('MicsDisplayModule');
    EventSystem.unsubscribe('MicsControlModule');
    EventSystem.unsubscribe('localClockOffset', this.updateLocalClockOffset.bind(this));
    EventSystem.unsubscribe('webRTCdebug', this.displayWebRTCDebugInfo.bind(this));
    EventSystem.unsubscribe('webRTCdebugState', this.webRTCdebugStateChange.bind(this));
    EventSystem.unsubscribe('nameRegistered', this.nameRegistered.bind(this));
    EventSystem.unsubscribe('remoteWebRTCdebug', this.receivedRemoteWebRTCDebug.bind(this));
    //window.removeEventListener("resize", _.debounce(() => {this.screenResized()},400));
    window.removeEventListener("resize", _.debounce(this.screenResized,400));
    //window.removeEventListener("touchstart", this._touchStart);
    //window.removeEventListener("touchmove", this._touchMove);

    this.socket.disconnect()
    //window.removeEventListener('onTouchMove', (e) => {e.preventDefault();}); 
    clearInterval(this.intervalID);
    clearTimeout(this.timerID);
    clearTimeout(this.timerID2);
    clearTimeout(this.countdown);

  }

  updateLocalClockOffset(localClockOffsetSeconds){
      this.setState({localClockOffset: (localClockOffsetSeconds*1000)});
  }

  _touchStart() {
      this.firstMove = true;
  }

  _touchMove(e) {

      if (this.firstMove) {
        e.preventDefault();
        this.firstMove = false;
      }

  }

  touchStart(e) {
    this.setState({touchDevice: true})
  }



  refreshClock() {

    let config={clockOffset: this.state.clockOffset, timeMasterClockOffset: this.state.timeMasterClockOffset}

    let updatedClockInfo = GlobalFunction.updateClock(this.state.clockLocalOffset, config);
  
    //console.log('Post: ', currentDate.getSeconds(), currentDate.getMilliseconds());
    EventSystem.publish('1000msHeartbeat', updatedClockInfo);
    this.setState({heartbeatsSinceLastTimeSync: this.state.heartbeatsSinceLastTimeSync + 1});
    if (this.state.heartbeatsSinceLastTimeSync > 900) {
      // resynch clocks every 15mins
      this.performTimeSync();
    }
    

    let currentDate = GlobalFunction.getAdjustedDate(this.state.clockLocalOffset, config);
    this.countdown = setTimeout(() => {
        this.refreshClock();
    }, 1000 - currentDate.getMilliseconds());
}

  onSendMessage(message, blob) {

    if (!this.state.mounted) {
      console.log('Not mounted got message', message)
      return;
    }


    message.clockOffset=this.state.clockOffset;
    message.myBuildVersion = window.myBuildVersion;
    // send the message to the server
    if (message.action==='release_time_master' ||
        message.action==='request_release_time_master' ||
        message.action==='set_time_master' ||
        message.action==='set_delay' ||
        message.action==='get_time_master') {
          this.socket.emit('TIME_MASTER', message);

          // tell any other clock on the dashboard about the toggle pf delay
        EventSystem.publish('ClockModule', message);

    }  else if (message.action === 'webcamCallStatusUpdate') {
        // need to keep a tally of active calls so that we know whether to allow the user to 
        // go into setup mode. we cannot go into setup mode if a call is active

        if (message.callStatus === 'active') {
            this.setState({activeCalls: this.state.activeCalls+1})
        } else  if (message.callStatus === 'none') {
            this.setState({activeCalls: this.state.activeCalls-1})
        } else if (message.callStatus === 'setup') {
            this.setState({webcamSetupActive: this.state.webcamSetupActive+1}, () => {
              //console.log('add',this.state.webcamSetupActive,message.instanceToken,message.callStatus);
            });
        } else  if (message.callStatus === 'endSetup') {
            this.setState({webcamSetupActive: this.state.webcamSetupActive-1}, () => {
              //console.log('subtract',this.state.webcamSetupActive,message.instanceToken,message.callStatus);
            });
        }

    }  else {
        this.socket.emit('SEND_MESSAGE', message);
    }

  }

  receivedRemoteWebRTCDebug (message) {
   
      //console.log ('got some remote debug info ', message, this.state.registeredName)
      if (message.callReceiver !== this.state.registeredName) {
        let webRTCDebugResultObjectArray = this.state.webRTCDebugResultObjectArray;
        // find existing element or add a new one
        let index = webRTCDebugResultObjectArray.findIndex(debugResultObject => debugResultObject.registeredName === message.callReceiver);
        if (index === -1) {
            // not found -> append to the end
            webRTCDebugResultObjectArray.push({registeredName: message.callReceiver , debugObject: [message.debugObject]})
        } else {
            webRTCDebugResultObjectArray[index].debugObject.push(message.debugObject);
        }            
        this.setState({webRTCDebugResultObjectArray: webRTCDebugResultObjectArray});
        if (this.state.currentSelectedWebRTC === message.callReceiver) {
          // we're updating the one we are currently viewing
          this.setState({debugObjectArray: webRTCDebugResultObjectArray[index].debugObject});
        }
    }
  }

  onResizeStart(layout, oldItem, newItem,
    placeholder, e, element) {
       //console.log('Start: className/'+element.className+' Height/'+element.style.height+'     newItem.h:'+newItem.h);
  }
  onResize(layout, oldItem, newItem,
    placeholder, e, element) {
      //console.log('During: className/'+element.className+' Height/'+element.style.height+'     newItem.h:'+newItem.h);
  }

  getHeightInPixels (heightUnits) {
    const gapBetweenCells = 10;
    let heightInPixels = 
        (this.state.rowHeight * heightUnits) + 
        (heightUnits===1 ? 0 : (gapBetweenCells * (heightUnits -1))) ;


    return heightInPixels;

  }


  onDragStop(layout, oldItem, newItem,
             placeholder, e, element) {
              
      if ((newItem.y + newItem.h) > this.props.selectedScreen.maxRows){
        newItem.y=oldItem.y;
        newItem.h=oldItem.h;
      } else {
        //this.setState({changeCount: this.state.changeCount + 1})   ;       
        let dimensions=this.state.dimensions;
        const thisDimensionRow= this.state.dimensions.findIndex((row) => row.i===newItem.i);
        if (thisDimensionRow <0 ) {
          // we have to add it
          let newDimensionRow = {};
          newDimensionRow.i = newItem.i;
          newDimensionRow.width=element.style.width;
          newDimensionRow.height = this.getHeightInPixels( newItem.h);
          dimensions.push(newDimensionRow);
        } else {
          // we have to update it
          dimensions[thisDimensionRow].width = element.style.width;
          dimensions[thisDimensionRow].height = this.getHeightInPixels( newItem.h);
        }
      
        this.setState({dimensions}, () => {});   
      }
  }

  onResizeStop(layout, oldItem, newItem,
               placeholder, e, element) {


    if ((newItem.y + newItem.h) > this.props.selectedScreen.maxRows){
      newItem.y=oldItem.y;
      newItem.h=oldItem.h;
    } else {
      let dimensions=this.state.dimensions;
        const thisDimensionRow= this.state.dimensions.findIndex((row) => row.i===newItem.i);
        
        if (thisDimensionRow <0 ) {
          // we have to add it
          let newDimensionRow = {};
          newDimensionRow.i = newItem.i;
          newDimensionRow.width=element.style.width;
          newDimensionRow.height = this.getHeightInPixels( newItem.h);
          dimensions.push(newDimensionRow);
        } else {
          // we have to update it
          dimensions[thisDimensionRow].width = element.style.width;
          dimensions[thisDimensionRow].height = this.getHeightInPixels( newItem.h);
        }
        
        this.setState({dimensions}, () => {});  
      }
  }

  disableDrag(setting) {
    this.setState({disableDrag: setting});
  }

  onTicketRaised(ticketResult) {

      //alert('Support ticket #' + ticketResult.issue.id + ' created')  
      this.setState({ticketID: ticketResult.issue.id});
    
  }

  screenDataLoaded() {
    let videoDevice = this.video.current;
    this.canvas.current.height = videoDevice.videoHeight;
    this.canvas.current.width = videoDevice.videoWidth;
    this.canvas.current.getContext('2d').drawImage(videoDevice, 0, 0);
    let dataUrl = this.canvas.current.toDataURL();
    this.setState({externalDataUrl: dataUrl});


    //let base64ImageContent = dataUrl.replace(/^data:image\/(png|jpg);base64,/, "");
     
    //this.setState({base64ImageContent: dataUrl});
    //let blob = this.base64ToBlob(base64ImageContent, 'image/png');
    //this.setState({base64ImageContent: blob});
    //imageDetails.base64ImageContent = base64ImageContent;
    //imageDetails.dataUrl = dataUrl;
    //this.setState({imageDetails: imageDetails});
    let tracks = videoDevice.srcObject.getTracks();
    tracks.forEach(track => track.stop());
    videoDevice.srcObject = null;
    videoDevice.removeEventListener('loadeddata', this.screenDataLoaded);
    // show the logging window again
    this.setState({showLog: true});
  }
 

  takeScreenshot() {

    
  

    // hide the logging window
    this.setState({showLog: false}, () => {

   
      let displayMediaOptions = 
          {video:  {cursor: "never",
                    displaySurface: "browser",
                    logicalSurface: true},
          audio: false};
      //displayMediaOptions    = { video: { mediaSource: "screen" ,displaySurface: "browser"} };
      //displayMediaOptions    = { video: { cursor: "always" ,displaySurface: "browser"} };
      let captureStream = null;
      let videoDevice = this.video.current;

      navigator.mediaDevices.getDisplayMedia(displayMediaOptions)
         .then((captureStream) => {
              //console.log(captureStream)

              videoDevice.addEventListener('loadeddata', this.screenDataLoaded);


              videoDevice.srcObject = captureStream;
            
              //this.video.current.pause();
              // copy from video to canvas
              
              // to stop
              //let tracks = this.video.current.srcObject.getTracks();
              //tracks.forEach(track => track.stop());
         })
         .catch((e) => {
              //alert('getDisplayMedia() error: ' + e.name);
              console.log('error');
              console.log(e);
              this.setState({showLog: true});
            });
      });
    
    }
  

  raiseTicket(ticketDetails) {

      let ticketObject = {};
      ticketObject.contactName = ticketDetails.contactName;
      ticketObject.email = ticketDetails.email;
      ticketObject.phone = ticketDetails.phone;
      ticketObject.subject = ticketDetails.subject;
      ticketObject.description = ticketDetails.description + '\n\n\n' ;

      // need to deserialise the log to send
      let logData = JSON.stringify(this.state.logData);
      ticketObject.logData = logData.replace(/{/gi, '\n{'); // add some newlines to make it format better

      ticketObject.companySiteName = this.props.userProfile[0].companySiteName;
      ticketObject.eventScreenID = this.props.selectedScreen.eventScreenID;
      ticketObject.eventID = this.props.selectedScreen.eventID;
      ticketObject.screenName = this.props.selectedScreen.screenName;
      ticketObject.base64ImageContent = ticketDetails.base64ImageContent; // get image from parent as it will always be ok
      //ticketObject.base64ImageContent = ""; 

      this.socket.emit('RAISE_TICKET', ticketObject);
  }

  createTicketNoLogging() {
      // open with special format to indicate no logging 
      let moduleIdentifier = [this.state.logData[0].elementID];
      this.setState({selectedModuleIdentifier: moduleIdentifier});
  }

    openLoggingWindow() {
        
        // open the first module 
        let moduleIdentifier = [this.state.logData[0].module_name ,this.state.logData[0].elementID, this.state.logData[0].name];
        this.setState({selectedModuleIdentifier: moduleIdentifier});

    }

    enableModuleLogging(moduleIdentifier){
        // we will first see if already enables
        let index = -1;
        if (this.state.logData.length > 0) {
            index=this.state.logData.findIndex(row => row.elementID===moduleIdentifier[1]);     
        }

        if (index === -1) {
            let logData = this.state.logData;
            let newRow = {};
            newRow.rowNum = logData.length;
            newRow.elementID = moduleIdentifier[1];
            newRow.moduleName = moduleIdentifier[0];
            newRow.instanceName = moduleIdentifier[2];
            newRow.loggingEnabled = false;
            newRow.logHistory = [];
            logData.push(newRow);

            // sort by name
            logData.sort(function(a, b) {
                var nameA = a.moduleName.toUpperCase()+a.instanceName.toUpperCase(); // ignore upper and lowercase
                var nameB = b.moduleName.toUpperCase()+b.instanceName.toUpperCase(); // ignore upper and lowercase
                if (nameA < nameB) {
                return -1;
                }
                if (nameA > nameB) {
                return 1;
                }
            
                // names must be equal
                return 0;
            });


          this.setState({logData});
      }
  }


  closeLog() {

    this.setState({selectedModuleIdentifier: [],
                   ticketID: 0});
    
  }

  toggleLogging(index) {

      
    let logData = this.state.logData;
    if (index !== -1) {
        logData[index].loggingEnabled = !logData[index].loggingEnabled;
        this.setState({logData,
                        forceRender: !this.state.forceRender});
    }

      //let moduleLogStatus = this.state.moduleLogStatus;
      //moduleLogStatus[moduleIdentifier[1]] = !moduleLogStatus[moduleIdentifier[1]];
      //this.setState({moduleLogStatus: moduleLogStatus});
     
    EventSystem.publish('logStatus'+logData[index].elementID, logData[index].loggingEnabled);

  }

  addLogEntry(moduleIdentifier, message) {

    if (this.props.selectedScreen.mode === 'test') {
      return
    }
//console.log('mode',this.props.selectedScreen.mode)
    let index = -1;
    if (this.state.logData.length > 0) {
        index=this.state.logData.findIndex(row => row.elementID===moduleIdentifier[1]);     
    }

    if (index === -1) {
        this.setState({noLogMessage: moduleIdentifier[0]+" is sending logData when it shouldn't. Seek support."})
              this.timerID = setTimeout(() => {
                // clear message atfter 4 seconds
                this.setState({noLogMessage: ""})
          }, 3000)
          return;
    }

    /**
     * New Strategy
     * Murphy will guarantee logging isnt turned on until after you have an issue
     * and it will be hard to reproduce.
     * So we will log and retain the last 50 items for each module, ensuring it doesn't grow too big.
     * If you enable logging, then the limit of 50 dissapears.
     */
    //if (this.state.logData[index].loggingEnabled || force) {
    let logData = this.state.logData;
    let logDataRow = {};
    let ourAdjustedTime =   Date.now() +
                            this.state.clockOffset -
                            this.state.timeMasterClockOffset + // the clockOffset in the message is from the sender
                            this.state.localClockOffset;
    logDataRow.logDate = ourAdjustedTime;
    logDataRow.humanDate = moment(ourAdjustedTime).format();
    let rowNum = logData[index].logHistory.length;
    logDataRow.row = rowNum;
    logDataRow.message = message;
    logData[index].logHistory.push(logDataRow);
    if (!this.state.logData[index].loggingEnabled) {
        if (logData[index].logHistory.length > 50) {
          logData[index].logHistory.splice(0, 1); // remove the earliest available entry
        }
    }

    this.setState({logData,
                    forceRender: !this.state.forceRender});
    
}

  rightClick(moduleIdentifier, e) {
        e.preventDefault();

        // moduleIdentifier holds 0-ModuleName, 1-elementID, 2-Name (optional)

        // need to see if this module is supporting log info or not
        // modules will register on mounting
        let index = -1;
        if (this.state.logData.length > 0) {
            index=this.state.logData.findIndex(row => row.elementID===moduleIdentifier[1]);     
        }

        if (index === -1) {
          // not found -> does not support logging
              this.setState({noLogMessage: moduleIdentifier[0]+" does not have logging capability"})
              this.timerID = setTimeout(() => {
                // clear message atfter 4 seconds
                this.setState({noLogMessage: ""});
          }, 3000);
          return;
        }

        this.setState({selectedModuleIdentifier: moduleIdentifier});


    /**
       * box-shadow: inset rgba(0, 0, 0, 0.28) 2px 2px 5px 0px, rgba(200, 200, 200, 0.11) 0px 0.6px 0px 0px, inset rgba(97, 97, 97, 0.42) -2px 0px 5px
       * border-right: 1px solid #e4e4e445;
        border-bottom: 4px solid #7b7b7b4a;
        border-top: 1px solid #bfbfbf3b;
        border-left: 1px solid #bfbfbf3b;


            box-shadow: 0px 6px 0px #262626, 0px 3px 15px rgba(0,0,0,.4), inset 0px 0px 3px rgba(255, 255, 255, 0.5);
     */
     


    //console.log('rightclick')
    //console.log(moduleIdentifier[0])
    //console.log(moduleIdentifier[1])
    //console.log(moduleIdentifier[2])
    //TextControlModule
    //264
    //Information
  }

/***********************************************************
 * 
 * createElement(el)
 * 
 * 
 ***********************************************************/

  createElement(el) {

    let thisModule= {};
    let moduleName=[];
    let parameters = {};

    // this gets filled based on setup preferences
    parameters.colours = this.state.colours;


    let border = "none";


    //let boxShadow = parameters.colours.boxShadow;
    //let borderTop = "1px solid #444444";
    let borderTop = "none";
    let boxShadow = "none";

    if (el.module_name === "ClockModule" ||
        el.module_name === "AnalogClockModule" ||
        el.module_name === "MicsDisplayModule" ||
        el.module_name === "MicsControlModule" ||
        el.module_name === "TimerDisplayModule" ) {
            boxShadow = "none";
            borderTop = "none";
    }


    if (this.state.configureWidgets) {
        border = "1px solid rgb(151, 232, 236)";
        borderTop = "1px solid rgb(151, 232, 236)";
    } else {
        if (this.props.selectedScreen.mode === 'test') {
            border = "1px dashed rgb(151, 232, 236)";
            borderTop = "1px dashed rgb(151, 232, 236)";
    }
    }
    //const boxStyle={border: (this.state.configureWidgets ? (this.state.disableDrag ? "1px dashed whitesmoke" : "1px solid whitesmoke") : "none"), 
    //

    
    //boxShadow = "none";
    //borderTop = border;
    const boxStyle={border: border, 
                    zIndex: this.state.disableDrag ? 0 : 1,
                    overscrollBehavior: "none",
                    boxShadow: boxShadow,
                    backgroundColor: parameters.colours.backgroundColor,
                    borderTop: borderTop,
                    color: parameters.colours.color}

    const removeStyle = {
      position: "absolute",
      right: "2px",
      top: 0,
      cursor: "pointer",
      color: "white"
    };
    el.i = el.event_screen_module_id;
    const elementID= el.event_screen_module_id;



    let thisLayout=[];

    
    
    const ComponentName=this.components[ el.module_name];
    //thisModule= this.state.modulesDefinition.find((row) => row.moduleName===el.moduleName);
    //thisModule.ID = elementID;
    //parameters.modulesDefinition=thisModule;
    parameters.config=el;
    parameters.config.ID=elementID;
    parameters.config.clockOffset=this.state.clockOffset;
    parameters.config.currentTimeMaster=this.state.currentTimeMaster;
    parameters.config.timeMasterClockOffset=this.state.timeMasterClockOffset;
    parameters.config.timeMaster = this.props.selectedScreen.timeMaster;
  





    parameters.device = {};
    parameters.device.isTouchDevice = ('ontouchstart' in document.documentElement);
    
    let mode="";
    let currentSuffix=0;
    if (!this.state.configureWidgets) {
      //console.log('Not configuring widgets');
      el.static = !this.state.configureWidgets;
      el.isDraggable=false;
      el.isResizable=false;

      el.i = elementID + ':false'
      mode="";
    } else {
      //console.log('Configuring widgets');
    
      if (this.state.disableDrag) {
        el.isDraggable=false;
        el.isResizable=false;
      } else {
        el.isDraggable=true;
        el.isResizable=true;
      }
      el.static = false;
      mode="setup";
      currentSuffix = el.i.substring(el.i.indexOf(':')+1);
      if (isNaN(currentSuffix)) {
        currentSuffix = 0;
      } else {
        currentSuffix = parseInt(currentSuffix,10) + 1;
      }
      el.i = elementID + ':' + currentSuffix;
    }    
    

    el.minW = parseInt(el.min_width, 10);
    el.minH = parseInt(el.min_height, 10);

    el.x = parseInt(el.x, 10);
    el.y = parseInt(el.y, 10);
    el.w = parseInt(el.w, 10);
    el.h = parseInt(el.h, 10);
    el.description=el.name;

    // check to see if we have the co-ords set locally and use those
    //let localIndex = el.i.replace(/:true|:false/i, '');
    //console.log('el.i='+el.i);
    let localPositions=JSON.parse(localStorage.getItem("localPostions_"+this.props.selectedScreen.eventScreenID));
    if (localPositions) {
      let localStorageRow = localPositions.findIndex((row) => row.i.substr(0, row.i.indexOf(':')) === elementID);
      //elementID= el.i.substr(0, el.i.indexOf(':'));
      if (localStorageRow > -1 && !this.state.designSeqNoChanged) {
        // use local position if the design hasn't changed since last time
        //console.log('Updating from local storage: '+el.i)
        el.x=localPositions[localStorageRow].x;
        if (localPositions[localStorageRow].y <= this.props.selectedScreen.maxRows) {
          // don't use stored row if it is greater than the max rows for the screen
          el.y=localPositions[localStorageRow].y;
        }
        el.w=localPositions[localStorageRow].w;
        el.h=localPositions[localStorageRow].h;
      }
    }

    // work out the dimensions
    let containerHeight = {};
    const thisDimensionRow= this.state.dimensions.findIndex((row) => row.i===el.i);
    if (thisDimensionRow === -1) {
      // we don't have the precise dimension as yet because we havent moved or resized the frid-item
      const gapBetweenCells = 10; // have to hardcode 
      containerHeight.container=(this.state.rowHeight * el.h) + 
                         (el.h===1 ? 0 : (gapBetweenCells * (el.h -1)))        
                        
    } else {
      let newHeight=this.state.dimensions[thisDimensionRow].height;
      containerHeight.container=newHeight;   //.replace(/px/i, '');
    }

    containerHeight.rows=el.h;
    containerHeight.rowHeight=this.state.rowHeight;
    containerHeight.maxCols = this.props.selectedScreen.maxCols;
    containerHeight.maxRows = this.props.selectedScreen.maxRows;
    

    // width
    
    if (this.state.dimensions.length > 0) {
      const thisDimensionIndex = this.state.dimensions.findIndex((row) => row.i===thisLayout.i);
      if (thisDimensionIndex !== -1)  {
        containerHeight.width=this.state.dimensions[thisDimensionIndex].width;
      }
    }

    parameters.containerHeight=containerHeight;
    parameters.userProfile=this.state.userProfile;

    // 20/Nov/2018 Removed this from the ComponentName push
    //disableDrag={this.disableDrag.bind(this)}                    
 
    let moduleIdentifier = [el.module_name ,elementID, el.name];
//console.log( 'create',el.module_name, elementID, el.name)
    const setupStyle={color: "#ffbe76", wordBreak: "break-word"}  
    if (mode === "setup" && (el.module_name != "ClockModule" && el.module_name != "AnalogClockModule")) {
        moduleName.push(<div style={setupStyle}key={el.i}>{el.module_name} <br/>{el.name}</div>)
    } else {
         
        moduleName.push(<ComponentName 
                              key={el.i} 
                              parameters={parameters} 
                              enableModuleLogging={() => this.enableModuleLogging(moduleIdentifier)}
                              addLogEntry={(message) => this.addLogEntry(moduleIdentifier, message)}
                              onSendMessage={this.onSendMessage} 
                              mode={mode} 
                            />);  
    }

   
    return (
          <div key={el.i} style={boxStyle} data-grid={el} name={moduleIdentifier}  onContextMenu={(e) =>  this.rightClick(moduleIdentifier, e)} >
              {<span  className="text">{moduleName}</span>}
          </div>
          );
  }

  //{<span className="text">{moduleName}</span>}
  //{<div  name={moduleIdentifier}  onContextMenu={this.rightClick} className="text">{moduleName}</div>}


  // We're using the cols coming back from this to calculate where to add new items.
  onBreakpointChange(breakpoint, cols) {
    this.setState({
      breakpoint: breakpoint,
      cols: cols
    });
  }

  onLayoutChange(layout) {

    if (layout.length > 0) {
      localStorage.setItem("localPostions_"+this.props.selectedScreen.eventScreenID, JSON.stringify(layout));
    }
    if (this.state.designSeqNoChanged) {
      // reset this as we have done at least one pass with the unchanged layout
      this.setState({designSeqNoChanged: false});
    }

    
  }



  
  closeAlert() {
    this.setState({ popupAlert: false });
  }   

  popupAlert() {
    this.setState({ popupAlert: true });
  } 
  

  exitDisplayClock (){
    this.props.exitDisplayClock();
  }

  toggleConfigureWidgets() {

    
    if (this.state.activeCalls !== 0 || this.state.webcamSetupActive !==0 ) {
      // don't go into setup mode of we have a y active calls
      return;
    }
 
    this.setState({configureWidgets: !this.state.configureWidgets}, () => {
        if (this.state.configureWidgets) {
          this.askTimeMaster('get_time_master');
        }
    });
    let messageObject={};
    messageObject.action='setup';
 
    
  }

  _onTouchMove(e) {
    if (this.state.configureWidgets) {
      // only disable touch movements when in config mode
    
      e.preventDefault();
      e.stopImmediatePropagation();
      //e.stopPropagation();
    }
  }
  
  refreshBrowser() {
    window.location.reload(true);
  }

  screenResized() {

    if (this.props.selectedScreen.mode === 'test') {
      return
    }
//console.log('mode:',this.props.selectedScreen.mode)
    this.addLogEntry(['displayClock', 'displayClock'], 'screen resized '+window.innerHeight);
    this.setState({rowHeight: this.calculateRowHeight(),
                   forceRenderRGL: !this.state.forceRenderRGL}, () => {
        this.addLogEntry(['displayClock', 'displayClock'], 'new rowHeight= '+this.state.rowHeight);
    });

  }

  displaySelectedDebugInfo(eventKey) {
      let index = this.state.webRTCDebugResultObjectArray.findIndex(debugResultObject => debugResultObject.registeredName === eventKey);
      if (index === -1) {
          // not found -> append to the end
          alert('Could not find the selected person');
      } else {
          let debugObjectArray = this.state.webRTCDebugResultObjectArray[index].debugObject;
          this.setState({debugObjectArray,
                         currentSelectedWebRTC: this.state.webRTCDebugResultObjectArray[index].registeredName});
          
      } 
  }

  displayWebRTCDebugInfo(webRTCDebugResultObject) {
    //console.log('got webrtc debug ',webRTCDebugResultObject)
    let webRTCDebugResultObjectArray = this.state.webRTCDebugResultObjectArray;
    // our own data is always element 0
  
    webRTCDebugResultObjectArray[0].debugObject.push(webRTCDebugResultObject.debugObject);
    webRTCDebugResultObjectArray[0].registeredName = webRTCDebugResultObject.registeredName;
    this.setState({webRTCDebugResultObjectArray: webRTCDebugResultObjectArray});
    
    if (this.state.currentSelectedWebRTC === webRTCDebugResultObject.registeredName) {
      // we're updating the one we are currently viewing
      this.setState({debugObjectArray: webRTCDebugResultObjectArray[0].debugObject});
    }
  }

  webRTCdebugStateChange(newState) {
    this.setState({showDebug: newState})
  }

  nameRegistered(registeredName) {
    console.log('displayClock received registeredName ',registeredName)
    this.setState({registeredName: registeredName,
                   currentSelectedWebRTC: registeredName})
  }

  closeDebug() {
      this.setState({showDebug: false})
    }

  createMenuItem(webRTCDebugResultObject) {
      return (<MenuItem key={webRTCDebugResultObject.registeredName} eventKey={webRTCDebugResultObject.registeredName}>{webRTCDebugResultObject.registeredName}</MenuItem>)
  

      //<MenuItem eventKey="2">Mary</MenuItem>
  }



  render() {
//console.log('rendering')
      let screenHeight = window.innerHeight + 500;

      const screenModelStyle={height: "100vh", width: "100vw"};
      const cogGlyphStyle={flex: "1 1 auto", position: "absolute", fontSize: "25px", right: "5px", top: "2px",color: "white", zIndex: 9999}
      
      const fullGlyphStyle={ flex: "0 1 auto",  fontSize: "25px", paddingTop: "2px", zIndex: 9999, display: this.state.iOSDevice ? "none" : "inline-flex"}
      const buildGlyphStyle={ flex: "0 1 auto",  fontSize: "25px", paddingTop: "2px", zIndex: 9999}
      const ticketGlyphStyle={ flex: "0 1 auto",  fontSize: "25px", paddingTop: "2px", zIndex: 9999}
      
      const logoutGlyphStyle={flex: "1 1 auto", position: "absolute", fontSize: "25px", 
                              top: "2px",
                              left: "5px", color: "white", zIndex: 9999}
      const toggleGlyphStyle={position: "absolute", left: "100px", top: "1px", height: "20px", width: "20px", color: "white", zIndex: 1000}
      const topBorder={opacity: this.state.micsVisible ? 1 : 0, position: "absolute", width: "100%", top: "32px", right: 0, zIndex: 100}
      const leftBorder={opacity: this.state.micsVisible ?  1 : 0, position: "absolute", top: "32px", left: 0, zIndex: 100}
      const bottomBorder={opacity: this.state.micsVisible ?  1 : 0, position: "absolute", bottom: 0, right: 0, zIndex: 100}
      const rightBorder={opacity: this.state.micsVisible ?  1 : 0, position: "absolute", top: "32px", right: 0, zIndex: 100}
      const connectionCountStyle={flex: "0 1 auto", height: "30px", lineHeight: "26px"}
      const badgeStyle={flex: "1 1 auto", backgroundColor: this.state.disableDrag ? "green" : "#4834d4", 
                        color: "white", fontSize: "16px"};
      //const socketIDStyle={flex: "1 1 auto", display: this.state.configureWidgets ? "block" : "none",position: "absolute", right: "50px", top: "1px", color: "black", backgroundColor: "white" }
      const socketIDStyle={flex: "0 1 auto", display: this.state.configureWidgets ? "block" : "none", color: "rgb(151, 232, 236)"}
           // mobilePortrait - 4 cols * 10 rows
      // mobileLandscape - 8 cols * 5 rows
      // tablet 8 cols * 13 rows
      // desktop 12 cols * 12 rows
      let cols={}
      let column=12;
      if (typeof this.props.selectedScreen.maxCols!=="undefined") {
        column=this.props.selectedScreen.maxCols;
      }
      cols={ lg: column, 
             md: column, 
             sm: column, 
             xs: column, 
             xxs: column }

     
      let setupText = <span>Move and<br/>resize widgets<br/><br/>Configure Clock</span>
      if (this.state.activeCalls) {
        setupText = <span>Hangup call to acces configuration</span>
      } else if (this.state.webcamSetupActive) {
        setupText = <span>Webcam still setting up</span>
      }

      let fullScreenToolTip = <span>Disdplay in<br/>full screen</span>
      if (this.state.fullScreen) {
          fullScreenToolTip = <span>Exit<br/>full screen</span>
      }

      const options = {defaultSortName: 'uniqueKey',
        defaultSortOrder: 'desc'
      };
     
      return (
      <div style={screenModelStyle} className="displayClock react-grid-layout" onTouchStart={this.touchStart.bind(this)} ref={this.container}>
        <Modal show={this.state.popupAlert} onHide={this.closeAlert}>
          <Modal.Header closeButton>
              <Modal.Title>Time Master Request</Modal.Title>
          </Modal.Header>
          <Modal.Body>
              You have been requested to give up control as the Time Master.
              <br/>
              <br/> 
              Contact details are: {this.state.timeMasterRequestorContact}
              
          </Modal.Body>
          <Modal.Footer>
              <Button onClick={this.closeAlert}>Close</Button>
          </Modal.Footer>
        </Modal>

        <RmModal  ref={this.rmModal} show={this.state.showDebug} style={{backgroundColor: "rgba(255,255,255, 0.5)"}}>
          <RmModalContent>
              <RmModalHeader fontSize ={window.innerWidth < 576 ? '20px' : '24px'}>
                  <span style={{whiteSpace: "nowrap"}}>Debug Info{' '}{' '}{' '}
                  <DropdownButton
                      title={this.state.currentSelectedWebRTC}
                      key='displayDebug'
                      id={"displayDebug"}
                      style={{paddingTop: "4px", paddingLeft: "20px"}}
                      onSelect={this.displaySelectedDebugInfo.bind(this)}
                  >
                      {_.map(this.state.webRTCDebugResultObjectArray, webRTCDebugResultObject => this.createMenuItem(webRTCDebugResultObject))}
                  </DropdownButton></span>
                  <div  onClick={this.closeDebug.bind(this)} style={{position: "absolute", right: 0, top: 0, cursor: "pointer", padding: "5px"}}>
                      <span style={{fontSize: "14px", lineHeight: "28px", verticalAlign: "top", paddingRight: "5px"}}>Close</span>
                      <i style={{fontSize: "28px"}} className="material-icons">close</i>                              
                  </div>
              </RmModalHeader>
              <RmModalBody style={{overflowY: "scroll", overflowX: "scroll"}}>
                  <BootstrapTable data={this.state.debugObjectArray} options={ options }  hover height='80%'>
                      <TableHeaderColumn  isKey={true} hidden={true} dataField='uniqueKey'>Chan</TableHeaderColumn>
                      <TableHeaderColumn  width="50px" dataField='channelID'>Chan</TableHeaderColumn>
                      <TableHeaderColumn  width="50px" dataField='sequence'>Seq</TableHeaderColumn>
                      <TableHeaderColumn  width="100px" dataFormat={formatTimestamp}>Time</TableHeaderColumn>
                      <TableHeaderColumn  width="320px" dataField='sourceMethod'>Method</TableHeaderColumn>
                      <TableHeaderColumn  width="200px" dataField='connectionState'>ConState</TableHeaderColumn>
                      <TableHeaderColumn  width="200px" dataField='iceConnectionState'>iceConState</TableHeaderColumn>
                      <TableHeaderColumn  width="200px" dataField='iceGatheringState'>iceGather</TableHeaderColumn>
                      <TableHeaderColumn  width="100px" dataField='peerIdentity'>Ident</TableHeaderColumn>
                      <TableHeaderColumn  width="100px" dataField='sctp'>SCTP</TableHeaderColumn>
                      <TableHeaderColumn  width="320px" dataField='signalingState'>SigState</TableHeaderColumn>
                  </BootstrapTable> 
              </RmModalBody>
          </RmModalContent>
      </RmModal>

        {/********************************************************************************************************************************** 
            TOP LINE STATUS & WARNINGS
        ***********************************************************************************************************************************/}  
       
        <div style={{display: "flex", justifyContent: "space-evenly", lineHeight: "30px", backgroundColor: "#3c3b3b", boxShadow: "inset 1px 0px 2px #0606068a",
                     borderBottomColor: "rgb(103, 98, 98)", borderBottomWidth: "1px" , borderBottomStyle: "solid", height: "30px"}}
              >  

            {/** Exit */}
            <RmToolTip  itemText="exit_to_app" itemType="icon" placement="bottom" 
                        onClick={this.exitDisplayClock.bind(this)}
                        style={logoutGlyphStyle} 
                        toolTipText={<span>Exit</span>}/>

            {/** RAISE TICKET <div onTouchStart={this.touchStart.bind(this)}></div> */}
            
            <RmToolTip  itemText="contact_support" itemType="icon" placement="bottom" 
                        onClick={this.createTicketNoLogging}
                        style={ticketGlyphStyle} 
                        toolTipText={<span>Create a<br/>support ticket</span>}/>
            

            {/** Conneciton Count */}
            <div ref="connectionCount" style={connectionCountStyle}>
              <Badge style={badgeStyle}>{this.state.clientConnections}</Badge>
            </div>

            {/** Unstable Connection */}
            <div style={{ flex: "1 1 auto", margin: "0 auto", width: "100%", textAlign: "center", 
                          color:"white", backgroundColor: "orange", position: "absolute", top: 0, height: "28px",
                          display: (this.state.consecutiveSocketErrorCount > 4 &&  this.state.consecutiveSocketErrorCount < 11 ?
                                    "block" : "none")}}>
                Internet connection unstable
            </div>

            {/** No Connection */}
            <div style={{flex: "1 1 auto",  margin: "0 auto", width: "100%", textAlign: "center", 
                          color:"white", backgroundColor: "red", position: "absolute", top: 0,  height: "28px",
                          display: (this.state.consecutiveSocketErrorCount > 10  ?
                                    "block" : "none")}}>
                Server connection unavailable
            </div>


            {/** LOGGING */}
            <RmToolTip  itemText="build" itemType="icon" placement="bottom" 
                        onClick={this.openLoggingWindow}
                        disabled={this.state.selectedModuleIdentifier.length > 0}
                        style={buildGlyphStyle} 
                        toolTipText={<span>Open Logging</span>}/>

            {/** Build Details*/}
            <div style={socketIDStyle}>
                <RmToolTip  itemText={"Build "+window.myBuildVersion} itemType="text" placement="bottom" 
                            noClick
                            toolTipText={<span>{this.state.socketID}</span>}/>
            </div>

            {/** FULL SCREEN */}
            <RmToolTip  itemText={this.state.fullScreen ? "fullscreen_exit" : "fullscreen"} itemType="icon" placement="bottom" 
                        onClick={this.state.fullScreen ? this.closeFullscreen : this.openFullScreen}
                        style={fullGlyphStyle} 
                        toolTipText={fullScreenToolTip}/>

            {/** Setup */}
            <RmToolTip  itemText="settings" itemType="icon" placement="bottom" 
                        disabled= {this.state.activeCalls !== 0 || this.state.webcamSetupActive !== 0 || (this.state.selectedModuleIdentifier.length > 0 && this.state.showLog)}
                        onClick={this.toggleConfigureWidgets}
                        style={cogGlyphStyle} 
                        toolTipText={setupText}/>
        </div> 

        {/* Need a few pixels to moved RGL down so that ants will fit properly */}
        <div style={{height: "4px", width: "100%"}}></div>

        {/********************************************************************************************************************************** 
              Build {' '} {window.myBuildVersion} {' - '} {this.state.socketID}
            Version Upgrade 
        ***********************************************************************************************************************************/} 
        <div style={{display: this.state.newProgramVersionAvailable ? "block" : "none",
                position: "absolute",
                top: "32px",
                left: "10px",
                color: "white",
                backgroundColor: "gray",
                zIndex: 1000,
                padding: "15px",
                boxShadow: "4px 4px 11px 1px #fffdfd69",
                whiteSpace: "nowrap"
                          
                        }}>
                  <span style={{paddingRight: "10px"}}>A new version of Orquestradio  is available</span> <span style={{color: "yellow", cursor: "pointer", fontWeight: "500px"}} onClick={this.refreshBrowser}>REFRESH</span>
        </div>


        {/********************************************************************************************************************************** 
            Logging Related
        ***********************************************************************************************************************************/}     

            <div style={{display: this.state.noLogMessage.length > 0 ? "block" : "none",
                   position: "absolute",
                   top: "30vh",
                   left: "40vw",
                   color: "black",
                   backgroundColor: "pink",
                   border: '1px solid black',
                   zIndex: 10000,
                   padding: "15px",
                   boxShadow: "rgb(255, 255, 255) 0 0 2px 0px, rgb(0, 0, 0) 9px 7px 11px 1px",
                   //boxShadow: "4px 4px 11px 1px #f7bf3d",
                   whiteSpace: "nowrap"
                }}>
                {this.state.noLogMessage}
            </div>

            <div style={{display: this.state.selectedModuleIdentifier.length > 0 && this.state.showLog ? "block" : "none",
                         position: "absolute",
                         top: "40px",
                         left: "10px",
                         zIndex: 9999}}>
                    <DisplayLog
                        logData = {this.state.logData}
                        colours = {this.state.colours}
                        touchDevice = {this.state.touchDevice}
                        ticketID = {this.state.ticketID}
                        screenDimensions = {this.state.screenDimensions}
                        moduleIdentifier = {this.state.selectedModuleIdentifier}
                        forceRender = {this.state.forceRender}
                        toggleLogging = {this.toggleLogging.bind(this)}
                        externalDataUrl = {this.state.externalDataUrl}
                        raiseTicket = {this.raiseTicket.bind(this)}
                        takeScreenshot = {this.takeScreenshot.bind(this)}
                        closeLog = {this.closeLog.bind(this)}/>
            </div>


        {/********************************************************************************************************************************** 
            GRID LAYOUT
        ***********************************************************************************************************************************/}     
              <FlashScreen />
              <ResponsiveReactGridLayout
                onLayoutChange={this.onLayoutChange}
                onBreakpointChange={this.onBreakpointChange}
                onDragStop={this.onDragStop}
                onResizeStop={this.onResizeStop}
                onResizeStart={this.onResizeStart}
                onResize={this.onResize}
                forceRenderRGL={this.state.forceRenderRGL}
                cols={cols}
                {...this.props}
                rowHeight={this.state.rowHeight}
              >
                {_.map(this.state.clockInfo, el => this.createElement(el))}
              </ResponsiveReactGridLayout>
            <div  style={topBorder} className="lineH"></div>	
            <div style={leftBorder}  className="lineV"></div>    
            <div  style={bottomBorder} className="lineH"></div>	
            <div style={rightBorder} className="lineV"></div>    

        {/********************************************************************************************************************************** 
            SCREEN CAPTURE
        ***********************************************************************************************************************************/}     
            <video  ref={this.video} autoPlay
                    style={{width: "25vw", visibility: 'hidden' , height: "15vh", position: "fixed", bottom: 0, left: 0, backgroundColor: 'white'}}>
            </video>
            <canvas  ref={this.canvas} 
                    style={{width: "25vw", visibility: 'hidden', height: "15vh", position: "fixed", bottom: "15vh", left: 0, backgroundColor: 'wheat'}}>
            </canvas>
            

      </div>
    );
  }
}

function formatTimestamp(cell, row) {
  let messageTime=moment(row.timestamp);
  //console.log(row)
  let messageTimeFormatted=messageTime.format('HH:mm:ss.SSSS');
  /*
  return `<div class="tooltip">${cell} <span class="tooltiptext">${tooltipText}</span></div>`
  */
 return messageTimeFormatted
}


export default DisplayClock; 

